
import { Card } from "@/components/ui/card";

interface PlaceholderTabContentProps {
  title: string;
  description: string;
}

const PlaceholderTabContent = ({ title, description }: PlaceholderTabContentProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
      <div className="rounded-xl border bg-card text-card-foreground">
        <div className="flex flex-col space-y-1.5 p-6">
          <h3 className="font-semibold leading-none tracking-tight">
            {title} Management
          </h3>
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        </div>
        <div className="p-6 pt-0">
          <p className="text-center text-muted-foreground py-12">
            {title} module is coming soon...
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderTabContent;
